import { SurrogacyStageEnum } from  "./models";

export const DEVELOPMENT_ENV = 'development';
export const PRODUCTION_ENV = 'production';

// mobile responsive consts
export const DESKTOP_SCREEN = 960;
export const MOBILE_SCREEN = 320;
export const WIDGET_SCREEN = 319;

// personalization data actions
export const SAVE_APP_DATA = "SAVE_APP_DATA";
export const CLEAR_ALL_DATA = "CLEAR_ALL_DATA";
export const RESET_APP_ERROR = 'RESET_APP_ERROR';
export const CHANGE_LANGUAGE = 'CHANGE_LANGUAGE';

export const UPDATE_STEP_COUNT = 'UPDATE_STEP_COUNT';

// COMMON
export const POSITIVE_RESPONSE = 'Yes';
export const NEGATIVE_RESPONSE = 'No';

export const YES_NO_OPTIONS = [
  { label: POSITIVE_RESPONSE, value: true},
  { label: NEGATIVE_RESPONSE, value: false}
];

export const EMBRYOS_NUMBER_OPTIONS = [
  { label: '1', value: 1 },
  { label: '2', value: 2 },
];

export const CHILD_NUMBER_OPTIONS = [
  { label: '0', value: 0 },
  { label: '1', value: 1 },
  { label: '2', value: 2 },
  { label: '3', value: 3 },
  { label: '4', value: 4 },
  { label: '5', value: 5 },
  { label: '6', value: 6 },
  { label: '7', value: 7 },
  { label: '8', value: 8 },
  { label: '9', value: 9 },
  { label: '10+', value: 10 },
];

export const SURROGACY_STAGE_OPTIONS = [
  { label: 'Before Transfer', value: SurrogacyStageEnum.BEFORE_TRANSFER },
  { label: '0 to 12 weeks after Transfer', value: SurrogacyStageEnum.WITHIN_12_WEEKS },
  { label: '12+1 to 15 weeks after Transfer', value: SurrogacyStageEnum.BETWEEN_12_15_WEEKS },
  { label: '15+1 to 25 weeks after Transfer', value: SurrogacyStageEnum.BETWEEN_15_25_WEEKS },
  { label: 'After 25 weeks but before Birth', value: SurrogacyStageEnum.AFTER_25 },
  { label: 'After Birth', value: SurrogacyStageEnum.AFTER_BIRTH },
];

export const MEDICAL_COST_OPTIONS = [
  { label: '$5.000', value: 5000 },
  { label: '$10.000', value: 10000 },
  { label: '$15.000', value: 15000 },
  { label: '$20.000', value: 20000 },
  { label: '$35.000', value: 35000 },
  { label: '$50.000', value: 50000 },
  { label: '$75.000', value: 75000 },
  { label: '$100.000', value: 100000 },
  { label: '$100.000+', value: 100001 },
];

export const PHONE_MASK = "(999)-999-9999";

export const NAVIGATION_LABEL_MAP = {
  0: 'Basic Information',
  1: 'Your Journey',
  2: 'Journey Specifics',
  3: 'Review Plans',
  4: 'Thank you',
}

export const NOTE_EMAIL = ' info@surroplans.com';
export const PHONE_INPUT_PLACEHOLDER = "(000)-000-00-00";
